import { render, staticRenderFns } from "./MangeSalesHours.vue?vue&type=template&id=24845f74&scoped=true"
import script from "./MangeSalesHours.vue?vue&type=script&lang=js"
export * from "./MangeSalesHours.vue?vue&type=script&lang=js"
import style0 from "./MangeSalesHours.vue?vue&type=style&index=0&id=24845f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24845f74",
  null
  
)

export default component.exports